//require('babel-polyfill');

const environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

const rawHost = process.env.HOST;
const hasUrlScheme = typeof rawHost === 'string' && /^https?:\/\//.test(rawHost);
const normalizedHost = hasUrlScheme
  ? '127.0.0.1'
  : String(rawHost || '127.0.0.1');

module.exports = Object.assign({
  host: normalizedHost,
  port: process.env.PORT,
  apiHost: process.env.APIHOST || '127.0.0.1',
  apiPort: process.env.APIPORT,
  app: {
    title: 'ASM STS',
    description: '',
    head: {
      titleTemplate: 'ASM STS : %s',
      meta: [
        { charset: 'utf-8' },
        { property: 'locale', content: 'fr_FR' },
        { property: 'title', content: 'ASM STS' },
        { property: 'description', content: "Connectez-vous à votre compte ASM STS pour la supervision et la surveillance à distance de l'état de fonctionnement des ascenseurs." },
        //{ charset: 'utf-8' },
        //{ property: 'og:site_name', content: '' },
        //{ property: 'og:image', content: '' },
        //{ property: 'og:locale', content: 'fr_FR' },
        //{ property: 'og:title', content: 'ASM STS' },
        //{ property: 'og:description', content: 'ASM STS' },
        //{ property: 'og:card', content: 'summary' },
        //{ property: 'og:site', content: '@amphidev' },
        //{ property: 'og:creator', content: '@amphidev' },
        //{ property: 'og:image:width', content: '200' },
        //{ property: 'og:image:height', content: '200' }
      ]
    }
  },

}, environment);
